import type { FunctionComponent } from 'react';

import styles from './Settings.module.less';

/**
 * SettingsPageSubheading is a subheading for the settings page.
 * It's not used that frequently, but is used enough to warrant its own component.
 */
const SettingsPageSubheading: FunctionComponent = ({ children }) => (
  <h4 className={styles.subheading}>
    {children}
  </h4>
);

export default SettingsPageSubheading;
